import { DomainError } from '@dma/shared';

export class InvalidScientificEntryError extends DomainError {
  constructor(reason: string) {
    super('INVALID_SCIENTIFIC_ENTRY', `Scientific entry is invalid: ${reason}`);
    this.name = 'InvalidScientificEntryError';
    Object.setPrototypeOf(this, InvalidScientificEntryError.prototype);
  }
}
